import React from 'react'
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
    drawerHeader: {
        overflowX: 'hidden',
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
      },
      content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
        height: '100%',
        '@media (max-width: 1050px)': {
          marginLeft: 0
        }
      },
      contentShift: {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
      }
})
)

const ContentWrapper = ({ open, children }) => {
    const classes = useStyles();
    return (
        <main style={{ padding: '0' }}
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
          {<div className={classes.drawerHeader} /> }
        { children }
      </main>
    )
}

export default ContentWrapper